import React from 'react';
import { useTranslation } from 'react-i18next';
import WebsiteLayout from '../layouts/WebsiteLayout';

const Privacy = () => {
  const { t, i18n } = useTranslation();

  return (
    <WebsiteLayout>
      <div className="py-5">
        {i18n.language === 'fr' ? (
          <div className="container mt-5">
            <h1>Politique de Confidentialité</h1>
            <p>
              Solutions TransportSansGaz (<strong>transportsg.solutions</strong>
              , <strong>TSG Solutions</strong>, <strong>TSG</strong>,{' '}
              <strong>TransportSansGaz Solutions</strong>, <em>je</em>,{' '}
              <em>nous</em> ou <em>on</em>) gère le site web{' '}
              <a
                href="https://transportsg.solutions"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://transportsg.solutions
              </a>{' '}
              (le "Service").
            </p>
            <p>
              Cette page vous informe de nos politiques concernant la collecte,
              l'utilisation et la divulgation de données personnelles lorsque
              vous utilisez notre service et des choix que vous avez associés à
              ces données.
            </p>
            <p>
              Nous utilisons vos données pour fournir et améliorer le service.
              En utilisant le Service, vous acceptez la collecte et
              l'utilisation des informations conformément à cette politique.
              Sauf définition contraire dans la présente politique de
              confidentialité, les termes utilisés dans la présente politique de
              confidentialité ont la même signification que dans nos conditions
              générales, accessibles à partir de{' '}
              <a
                href="https://transportsg.solutions"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://transportsg.solutions
              </a>
              .
            </p>

            <h2>Collecte et utilisation des données</h2>
            <p>
              Nous recueillons plusieurs types d'informations à des fins
              diverses afin de vous fournir et de continuellement améliorer
              notre service.
            </p>

            <h3>Types de données collectées</h3>
            <h4>Données à caractère personnel</h4>
            <p>
              Lors de l'utilisation de notre Service, nous pouvons vous demander
              de nous fournir certaines informations personnelles identifiables
              pouvant être utilisées pour vous contacter ou vous identifier («
              Données personnelles »). Ces informations peuvent inclure, sans
              s'y limiter :
            </p>
            <ul>
              <li>Adresse électronique</li>
              <li>Prénom et nom de famille</li>
              <li>Numéro de téléphone</li>
              <li>Adresse, État/Province, Code Postal, Ville</li>
            </ul>

            <h4>Cookies et données d'utilisation</h4>
            <h5>Données d'utilisation</h5>
            <p>
              Nous pouvons également recueillir des informations sur la manière
              dont le Service est accessible et utilisé (« Données d'utilisation
              »). Ces données peuvent inclure, par exemple, l'adresse IP de
              votre ordinateur, le type et la version de votre navigateur, les
              pages de notre Service que vous consultez, l'heure et la date de
              votre visite, le temps passé sur ces pages, les identifiants
              uniques des appareils ainsi que d'autres données de diagnostic.
            </p>
            <h5>Données de suivi et cookies</h5>
            <p>
              Nous utilisons des cookies et des technologies de suivi similaires
              pour suivre l'activité sur notre Service et conserver certaines
              informations. Les cookies sont des fichiers contenant un petit
              nombre de données pouvant inclure un identifiant unique anonyme.
              Ils sont envoyés à votre navigateur depuis un site web et stockés
              sur votre appareil. D'autres technologies de suivi, telles que les
              balises, tags et scripts, sont également utilisées pour collecter
              et suivre des informations, et pour améliorer et analyser notre
              Service.
            </p>
            <p>
              Vous pouvez configurer votre navigateur pour refuser tous les
              cookies ou pour vous avertir lors de l'envoi d'un cookie.
              Toutefois, si vous n'acceptez pas les cookies, il se peut que vous
              ne puissiez pas utiliser certaines parties de notre Service.
            </p>
            <p>
              <strong>Exemples de Cookies que nous utilisons :</strong>
            </p>
            <ul>
              <li>
                <strong>Cookies de session :</strong> utilisés pour exploiter
                notre Service.
              </li>
              <li>
                <strong>Cookies de préférence :</strong> utilisés pour mémoriser
                vos préférences et divers paramètres.
              </li>
              <li>
                <strong>Cookies de sécurité :</strong> utilisés à des fins de
                sécurité.
              </li>
            </ul>

            <h2>Utilisation des données</h2>
            <p>
              Solutions TransportSansGaz utilise les données recueillies à des
              fins diverses :
            </p>
            <ul>
              <li>Fournir et maintenir le Service</li>
              <li>Vous informer des modifications apportées au Service</li>
              <li>
                Vous permettre de participer aux fonctionnalités interactives du
                Service lorsque vous le souhaitez
              </li>
              <li>Fournir une assistance et un soutien aux clients</li>
              <li>
                Fournir des analyses ou des informations utiles afin d'améliorer
                le Service
              </li>
              <li>Veiller sur l'utilisation du Service</li>
              <li>Détecter, prévenir et traiter les problèmes techniques</li>
            </ul>

            <h2>Transferts de données</h2>
            <p>
              Votre consentement à la présente politique de confidentialité,
              suivi de la communication de ces informations, représente votre
              accord à ce transfert. Solutions TransportSansGaz prendra toutes
              les mesures raisonnablement nécessaires pour s'assurer que vos
              données sont traitées en toute sécurité et conformément à cette
              politique. Aucun transfert de vos données personnelles n'aura lieu
              vers une organisation ou un pays à moins qu'il n'existe des
              contrôles adéquats, notamment concernant la sécurité de vos
              données et autres informations personnelles.
            </p>
            <p>
              Si vous êtes situé hors du Canada et choisissez de nous fournir
              des informations, veuillez noter que nous transférons ces données,
              y compris les données personnelles, au Canada où elles seront
              traitées.
            </p>

            <h2>Divulgation des données</h2>
            <h3>Exigences légales</h3>
            <p>
              Solutions TransportSansGaz peut divulguer vos données personnelles
              en croyant de bonne foi qu'une telle action est nécessaire pour :
            </p>
            <ul>
              <li>Se conformer à une obligation légale</li>
              <li>
                Protéger ou défendre les droits ou les biens de Solutions
                TransportSansGaz
              </li>
              <li>
                Prévenir ou enquêter sur d'éventuels actes répréhensibles en
                rapport avec le Service
              </li>
              <li>Répondre à des exigences légales</li>
            </ul>

            <h2>Sécurité des données</h2>
            <p>
              La sécurité de vos données est importante pour nous, mais
              rappelez-vous qu'aucune méthode de transmission sur Internet ou de
              stockage électronique n'est garantie à 100 %. Bien que nous nous
              efforçons d'utiliser des moyens commercialement acceptables pour
              protéger vos données personnelles, nous ne pouvons en garantir la
              sécurité absolue.
            </p>

            <h2>Fournisseurs de service</h2>
            <p>
              Nous pouvons employer des sociétés et des individus tiers pour
              faciliter notre Service (« fournisseurs de services »), pour
              fournir le Service en notre nom, pour effectuer des services liés
              au Service ou pour nous aider à analyser l'utilisation de notre
              Service.
            </p>
            <p>
              Ces tiers ont accès à vos données personnelles uniquement dans le
              but d'exécuter ces tâches en notre nom et sont tenus de ne pas les
              divulguer ou les utiliser à d'autres fins.
            </p>

            <h2>Analytique</h2>
            <p>
              Nous pouvons faire appel à des fournisseurs de services tiers pour
              surveiller et analyser l'utilisation de notre Service.
            </p>
            <p>
              <strong>Google Analytics :</strong> Google Analytics est un
              service d'analyse web offert par Google qui suit et rapporte le
              trafic sur les sites web. Google utilise les données collectées
              pour contrôler l'utilisation de notre Service. Ces données sont
              partagées avec d'autres services de Google, et Google peut
              utiliser ces informations pour contextualiser et personnaliser les
              publicités de son propre réseau publicitaire. Vous pouvez refuser
              que votre activité sur le Service soit transmise à Google
              Analytics en installant le module complémentaire de refus de
              Google Analytics pour navigateur. Pour en savoir plus sur les
              pratiques de confidentialité de Google, veuillez consulter la page{' '}
              <a
                href="https://policies.google.com/privacy?hl=fr"
                target="_blank"
                rel="noopener noreferrer"
              >
                Confidentialité et conditions d'utilisation de Google
              </a>
              .
            </p>

            <h2>Liens vers d'autres sites</h2>
            <p>
              Notre Service peut contenir des liens vers d'autres sites qui ne
              sont pas exploités par nous. En cliquant sur un lien tiers, vous
              serez redirigé vers le site de ce tiers. Nous vous recommandons
              vivement de consulter la politique de confidentialité de chaque
              site que vous visitez.
            </p>
            <p>
              Nous n'avons aucun contrôle sur, et n'assumons aucune
              responsabilité quant au contenu, aux politiques de confidentialité
              ou aux pratiques des sites ou services tiers.
            </p>

            <h2>Vie privée des enfants</h2>
            <p>
              Notre Service ne s'adresse pas aux personnes de moins de 18 ans («
              enfants »). Nous ne recueillons pas sciemment d'informations
              permettant d'identifier une personne de moins de 18 ans. Si vous
              êtes parent ou tuteur et que vous constatez que vos enfants nous
              ont fourni des données personnelles, veuillez nous contacter. Si
              nous apprenons que nous avons recueilli des données personnelles
              auprès d'enfants sans vérification du consentement parental, nous
              prendrons des mesures pour supprimer ces informations de nos
              serveurs.
            </p>

            <h2>Modifications de la politique de confidentialité</h2>
            <p>
              Nous pouvons mettre à jour notre politique de confidentialité de
              temps à autre. Nous vous informerons de tout changement en
              publiant la nouvelle politique sur cette page.
            </p>
            <p>
              Nous vous notifierons par courrier électronique et/ou par un avis
              bien visible sur notre Service, avant que les modifications
              n'entrent en vigueur, et nous mettrons à jour la « date d'entrée
              en vigueur » indiquée en haut de cette politique.
            </p>
            <p>
              Il vous est conseillé de consulter régulièrement cette politique
              de confidentialité pour prendre connaissance de toute
              modification. Les modifications apportées à la présente politique
              entrent en vigueur dès leur publication sur cette page.
            </p>

            <h2>Nous joindre</h2>
            <p>
              Si vous avez des questions concernant cette politique de
              confidentialité, veuillez nous contacter :
            </p>
            <ul>
              <li>
                Par courrier électronique :{' '}
                <a href="mailto:info@transportsg.solutions">
                  info@transportsg.solutions
                </a>
              </li>
            </ul>
          </div>
        ) : (
          <div className="container mt-5">
            <h1>Privacy Policy</h1>
            <p>
              Solutions TransportSansGaz (“
              <strong>transportsg.solutions</strong>”, “TSG Solutions”, “TSG”,
              “TransportSansGaz Solutions”, “us”, “we” or “our”) operates the{' '}
              <a
                href="https://transportsg.solutions"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://transportsg.solutions
              </a>{' '}
              website (the “Service”).
            </p>
            <p>
              This page informs you of our policies regarding the collection,
              use, and disclosure of personal data when you use our Service and
              the choices you have associated with that data.
            </p>
            <p>
              We use your data to provide and improve the Service. By using the
              Service, you agree to the collection and use of information in
              accordance with this policy. Unless otherwise defined in this
              Privacy Policy, terms used in this Privacy Policy have the same
              meanings as in our Terms and Conditions, accessible from{' '}
              <a
                href="https://transportsg.solutions"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://transportsg.solutions
              </a>
              .
            </p>

            <h2>Information Collection And Use</h2>
            <p>
              We collect several different types of information for various
              purposes to provide and improve our Service to you.
            </p>

            <h3>Types of Data Collected</h3>
            <h4>Personal Data</h4>
            <p>
              While using our Service, we may ask you to provide us with certain
              personally identifiable information that can be used to contact or
              identify you (“Personal Data”). Personally identifiable
              information may include, but is not limited to:
            </p>
            <ul>
              <li>Email address</li>
              <li>First name and last name</li>
              <li>Phone number</li>
              <li>Address, State, Province, ZIP/Postal code, City</li>
            </ul>

            <h4>Cookies and Usage Data</h4>
            <h5>Usage Data</h5>
            <p>
              We may also collect information on how the Service is accessed and
              used (“Usage Data”). This Usage Data may include information such
              as your computer’s Internet Protocol address (e.g. IP address),
              browser type, browser version, the pages of our Service that you
              visit, the time and date of your visit, the time spent on those
              pages, unique device identifiers, and other diagnostic data.
            </p>
            <h5>Tracking &amp; Cookies Data</h5>
            <p>
              We use cookies and similar tracking technologies to track the
              activity on our Service and hold certain information. Cookies are
              files with a small amount of data which may include an anonymous
              unique identifier. Cookies are sent to your browser from a website
              and stored on your device. Other tracking technologies such as
              beacons, tags, and scripts are also used to collect and track
              information and to improve and analyze our Service.
            </p>
            <p>
              You can instruct your browser to refuse all cookies or to indicate
              when a cookie is being sent. However, if you do not accept
              cookies, you may not be able to use some portions of our Service.
            </p>
            <p>
              <strong>Examples of Cookies we use:</strong>
            </p>
            <ul>
              <li>
                <strong>Session Cookies:</strong> We use Session Cookies to
                operate our Service.
              </li>
              <li>
                <strong>Preference Cookies:</strong> We use Preference Cookies
                to remember your preferences and various settings.
              </li>
              <li>
                <strong>Security Cookies:</strong> We use Security Cookies for
                security purposes.
              </li>
            </ul>

            <h2>Use of Data</h2>
            <p>
              Solutions TransportSansGaz uses the collected data for various
              purposes:
            </p>
            <ul>
              <li>To provide and maintain the Service</li>
              <li>To notify you about changes to our Service</li>
              <li>
                To allow you to participate in interactive features of our
                Service when you choose to do so
              </li>
              <li>To provide customer care and support</li>
              <li>
                To provide analysis or valuable information so that we can
                improve the Service
              </li>
              <li>To monitor the usage of the Service</li>
              <li>To detect, prevent and address technical issues</li>
            </ul>

            <h2>Transfer Of Data</h2>
            <p>
              Your information, including Personal Data, may be transferred to —
              and maintained on — computers located outside of your state,
              province, country, or other governmental jurisdiction where the
              data protection laws may differ from those of your jurisdiction.
            </p>
            <p>
              If you are located outside Canada and choose to provide
              information to us, please note that we transfer the data,
              including Personal Data, to Canada and process it there.
            </p>
            <p>
              Your consent to this Privacy Policy followed by your submission of
              such information represents your agreement to that transfer.
            </p>
            <p>
              Solutions TransportSansGaz will take all steps reasonably
              necessary to ensure that your data is treated securely and in
              accordance with this Privacy Policy and no transfer of your
              Personal Data will take place to an organization or a country
              unless there are adequate controls in place including the security
              of your data and other personal information.
            </p>

            <h2>Disclosure Of Data</h2>
            <h3>Legal Requirements</h3>
            <p>
              Solutions TransportSansGaz may disclose your Personal Data in the
              good faith belief that such action is necessary to:
            </p>
            <ul>
              <li>Comply with a legal obligation</li>
              <li>
                Protect and defend the rights or property of Solutions
                TransportSansGaz
              </li>
              <li>
                Prevent or investigate possible wrongdoing in connection with
                the Service
              </li>
              <li>
                Protect the personal safety of users of the Service or the
                public
              </li>
              <li>Protect against legal liability</li>
            </ul>

            <h2>Security Of Data</h2>
            <p>
              The security of your data is important to us, but remember that no
              method of transmission over the Internet, or method of electronic
              storage, is 100% secure. While we strive to use commercially
              acceptable means to protect your Personal Data, we cannot
              guarantee its absolute security.
            </p>

            <h2>Service Providers</h2>
            <p>
              We may employ third party companies and individuals to facilitate
              our Service (“Service Providers”), to provide the Service on our
              behalf, to perform Service-related services, or to assist us in
              analyzing how our Service is used.
            </p>
            <p>
              These third parties have access to your Personal Data only to
              perform these tasks on our behalf and are obligated not to
              disclose or use it for any other purpose.
            </p>

            <h2>Analytics</h2>
            <p>
              We may use third-party Service Providers to monitor and analyze
              the use of our Service.
            </p>
            <p>
              <strong>Google Analytics:</strong> Google Analytics is a web
              analytics service offered by Google that tracks and reports
              website traffic. Google uses the data collected to track and
              monitor the use of our Service. This data is shared with other
              Google services. Google may use the collected data to
              contextualize and personalize the ads of its own advertising
              network. You can opt out of having your activity on the Service
              made available to Google Analytics by installing the Google
              Analytics opt-out browser add-on. The add-on prevents the Google
              Analytics JavaScript (ga.js, analytics.js, and dc.js) from sharing
              information with Google Analytics about your visit activity. For
              more information on the privacy practices of Google, please visit
              the{' '}
              <a
                href="https://policies.google.com/privacy?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Privacy &amp; Terms
              </a>
              .
            </p>

            <h2>Links To Other Sites</h2>
            <p>
              Our Service may contain links to other sites that are not operated
              by us. If you click on a third party link, you will be directed to
              that third party’s site. We strongly advise you to review the
              Privacy Policy of every site you visit.
            </p>
            <p>
              We have no control over and assume no responsibility for the
              content, privacy policies, or practices of any third party sites
              or services.
            </p>

            <h2>Children’s Privacy</h2>
            <p>
              Our Service does not address anyone under the age of 18
              (“Children”).
            </p>
            <p>
              We do not knowingly collect personally identifiable information
              from anyone under the age of 18. If you are a parent or guardian
              and you are aware that your Children have provided us with
              Personal Data, please contact us. If we become aware that we have
              collected Personal Data from children without verification of
              parental consent, we take steps to remove that information from
              our servers.
            </p>

            <h2>Changes To This Privacy Policy</h2>
            <p>
              We may update our Privacy Policy from time to time. We will notify
              you of any changes by posting the new Privacy Policy on this page.
            </p>
            <p>
              We will let you know via email and/or a prominent notice on our
              Service, prior to the change becoming effective, and update the
              “effective date” at the top of this Privacy Policy.
            </p>
            <p>
              You are advised to review this Privacy Policy periodically for any
              changes. Changes to this Privacy Policy are effective when they
              are posted on this page.
            </p>

            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please
              contact us:
            </p>
            <ul>
              <li>
                By email:{' '}
                <a href="mailto:info@transportsg.solutions">
                  info@transportsg.solutions
                </a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </WebsiteLayout>
  );
};

export default Privacy;
